import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEng from "../../resources/locales/en/translation.json";
import translationEsp from "../../resources/locales/es/translation.json";
import translationFra from "../../resources/locales/fr/translation.json";
import translationDeu from "../../resources/locales/de/translation.json";
import translationIta from "../../resources/locales/it/translation.json";
import translationPor from "../../resources/locales/pt/translation.json";
import translationZho from "../../resources/locales/zh/translation.json";

const fallbackLng = ["es"];

const availableLanguages = ["es", "en", "fr", "de", "it", "pt", "zh"];

const resources = {
  es: {
    translation: translationEsp
  },
  en: {
    translation: translationEng
  },
  fr: {
    translation: translationFra
  },
  de: {
    translation: translationDeu
  },
  it: {
    translation: translationIta
  },
  pt: {
    translation: translationPor
  },
  zh: {
    translation: translationZho
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,

    detection: {
      // El idioma del navegador no define el arranque. Español salvo que la persona ya haya elegido otro.
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "tecccUiLanguage",
      checkWhitelist: true
    },

    debug: false,

    whitelist: availableLanguages,
    supportedLngs: availableLanguages,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
